exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nul[data-v-4b04e087]{width:100%;overflow-x:auto;display:-webkit-box;display:-ms-flexbox;display:flex;padding:.27rem .2rem\n}\nul[data-v-4b04e087]::-webkit-scrollbar{display:none\n}\nul li[data-v-4b04e087]{-ms-flex-negative:0;flex-shrink:0;width:3.76rem;margin-right:.17rem\n}\nul li img[data-v-4b04e087]{width:3.76rem;height:2.11rem;border-radius:.16rem\n}", ""]);

// exports
